import checkoutsApi from "../api/resources/checkoutsApi";
import cartService from "./cartService";

export default {
  store(data) {
    const token = cartService.instance();
    
    return checkoutsApi.store(token, data);
  }
}